import country from '@/mixins/getCountryDetails.js'
// import TRANSFER_DETAILS from '@/assets/mockTransferDetails.json'
import {
  ASSETS,
  DEFAULT_TRANSFER_DETAILS,
  GLOBAL_FIAT_CURRENCIES,
  LOCAL_COUNTRIES,
  GLOBAL_NON_USD_FIAT_CURRENCIES
} from '@/utils/constants.js'

export default {
  mixins: [country],
  data () {
    return {}
  },
  methods: {
    async getWalletAddresses () {
      this.isLoading = true
      await this.$store
        .dispatch('transactions/getWalletAddresses')
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
    },
    async getTransferDetails () {
      await this.$store
        .dispatch('auth/transferDetails')
        .then(() => {})
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getBusinessConfigurations () {
      this.$store
        .dispatch('auth/businessConfiguration')
        .then(() => {})
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
    },
    setDefaultCurrencies () {
      const transferDetails = this.$store.state.auth.transferDetails
      const details = transferDetails.find((detail) => detail.is_enabled)
      this.$store.dispatch('common/setSecondaryCurrency', details.to)
      this.$store.dispatch('common/setActiveCurrency', details.from)
      return details
    },
    getLocalDepositDetails (currency1, currency2) {
      const transferDetails = this.$store.state.auth.transferDetails
      const currenciesDetail = transferDetails.find(
        (detail) => detail.from === currency1 && detail.to === currency2
      )
      return currenciesDetail || {}
    },
    getDetails () {
      this.walletDetails = {
        walletDetails: {
          assetType: this.recipientInfo.asset,
          walletAddress: this.recipientInfo.walletAddress,
          network: this.recipientInfo.network
        }
      }
      this.destinationDetails = {
        bankDetails: {
          accountNumber: this.recipientInfo.accountNo,
          routingNumber: this.recipientInfo.routingNo,
          bankName: this.recipientInfo.bankName,
          country: this.recipientInfo.bankCountry,
          accountName: this.recipientInfo.accountName,
          bankCode: this.recipientInfo.bankCode,
          city: this.recipientInfo.bankCity,
          bankAddress: this.recipientInfo.bankAddress,
          swiftCode: this.recipientInfo.swiftCode,
          bankBranch: this.recipientInfo.bankBranch,
          district: this.recipientInfo.bankDistrict,
          postalCode: this.recipientInfo.bankPostalCode,
          isWithinUs: this.recipientInfo.bankCountry === 'US' ? 'yes' : 'no',
          intermediaryBank:
            this.recipientInfo.bankCountry === 'US' ||
            this.transferSourceIsGlobalFiat
              ? null
              : {
                  bankName: this.recipientInfo.intermediaryBankName,
                  bankAddress: this.recipientInfo.intermediaryBankAddress,
                  reference: this.recipientInfo.intermediaryBankReference,
                  swiftCode: this.recipientInfo.intermediaryBankSwiftCode
                }
        },
        intermediaryBank: !this.recipientInfo.intermediaryBankName
          ? null
          : {
              bankName: this.recipientInfo.intermediaryBankName,
              bankAddress: this.recipientInfo.intermediaryBankAddress,
              reference: this.recipientInfo.intermediaryBankReference,
              swiftCode: this.recipientInfo.intermediaryBankSwiftCode
            }
      }
      if (
        !this.transferDestinationIsAsset &&
        !this.transferDestinationIsLocal
      ) {
        this.destinationDetails.personalDetails = {
          name: this.recipientInfo.recipientName,
          country: this.recipientInfo.recipientCountry,
          city: this.recipientInfo.recipientCity,
          address: this.recipientInfo.recipientAddress,
          district: this.recipientInfo.recipientDistrict,
          postalCode: this.recipientInfo.recipientPostalCode
        }
      }
    },
    async initiateTransferAsset () {
      this.isLoading = true
      await this.getDetails()
      const vm = this
      const details = {
        assetDepositID: this.assetDepositId,
        destinationCurrency: this.country2.currency,
        note: this.note,
        reason: this.transferDetails.transferReason
      }
      if (this.usedBeneficiary) {
        details.beneficiaryID = this.beneficiaryID
      } else {
        details.beneficiaryDetails = this.transferDestinationIsAsset
          ? this.walletDetails
          : this.destinationDetails
      }
      this.$store
        .dispatch('terminal/initiateAssetTransfer', details)
        .then(() => {
          this.isLoading = false
          if (this.fromBalance) {
            this.closeAuthDialog()
            this.showTransferProcessingDialog = true
          } else {
            this.$store.dispatch(
              'transactions/setCurrentTransaction',
              this.$store.state.terminal.transferInfo.transfer || {}
            )
            this.$store.dispatch(
              'transactions/setTransactionDetails',
              this.$store.state.terminal.transferInfo.transfer || {}
            )
            this.$store.dispatch(
              'terminal/setDepositWalletView',
              'deposit-confirmed'
            )
            this.$store.dispatch('terminal/setAssetTransferState', 'successful')
            this.$emit('showMakePayment')
          }
        })
        .catch((error) => {
          this.$store.dispatch('terminal/setAssetTransferState', 'failed')
          this.showVerifyAuthDialog = false
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$swal({
            icon: 'error',
            title: 'Oops',
            text: err,
            iconColor: this.$primaryColor,
            allowOutsideClick: false
          })
        })
        .finally(() => {
          this.isLoading = false
          this.showVerifyAuthDialog = false
        })
    }
  },
  computed: {
    beneficiaryID () {
      return this.$store.state.terminal.beneficiaryID
    },
    usedBeneficiary () {
      return this.$store.state.terminal.usedBeneficiary
    },
    recipientInfo () {
      return (
        this.$store.state.terminal.transferTerminalDetails
          .recipientInformation || {}
      )
    },
    assetDepositId () {
      return this.$store.state.terminal.assetDepositId
    },
    transferSourceIsGlobalFiat () {
      const currencies = GLOBAL_FIAT_CURRENCIES.map((currency) => currency.name)
      return currencies.includes(this.activeCountry)
    },
    transferDestinationIsGlobalFiat () {
      const currencies = GLOBAL_FIAT_CURRENCIES.map((currency) => currency.name)
      return currencies.includes(this.secondaryCountry)
    },
    transferDestinationIsGlobalNonUsdFiat () {
      const currencies = GLOBAL_NON_USD_FIAT_CURRENCIES.map(
        (currency) => currency.name
      )
      return currencies.includes(this.secondaryCountry)
    },
    transferDestinationIsUSD () {
      return this.country2.currency === this.$CURRENCY.USD
    },
    transferDestinationIsGHS () {
      return this.country2.currency === this.$CURRENCY.GHS
    },
    transferDestinationIsLocal () {
      const currencies = LOCAL_COUNTRIES.map((asset) => asset.name)
      return currencies.includes(this.secondaryCountry)
    },
    transferSourceIsAsset () {
      const assets = ASSETS.map((asset) => asset.name)
      return assets.includes(this.activeCountry)
    },
    transferSourceIsLocal () {
      const currencies = LOCAL_COUNTRIES.map((asset) => asset.name)
      return currencies.includes(this.activeCountry)
    },
    transferDestinationIsAsset () {
      const assets = ASSETS.map((asset) => asset.currency)
      return assets.includes(this.secondaryCurrency)
    },
    activeCountry () {
      return this.$store.state.common.activeCountry
    },
    secondaryCountry () {
      return this.$store.state.common.secondaryCountry
    },
    activeCurrency () {
      return this.country.currency
    },
    secondaryCurrency () {
      return this.country2.currency
    },
    transferInfo () {
      const transferDetails = this.$store.state.auth.transferDetails
      if (transferDetails && Object.keys(transferDetails).length > 0) {
        // const transferDetails = TRANSFER_DETAILS
        const details = transferDetails.find(
          (detail) =>
            detail.from === this.activeCurrency &&
            detail.to === this.secondaryCurrency
        )
        return details || DEFAULT_TRANSFER_DETAILS
      }
      return []
    },
    exchangeRate () {
      const exchangeRate = this.transferInfo.exchange_rate
      return this.transferInfo.division_operator
        ? 1 / exchangeRate
        : exchangeRate || 0
    },
    exchangeRateBase () {
      return this.transferInfo.exchange_rate
    },
    percentageFees () {
      return this.transferInfo.fees_percentage || 0
    },
    flatFees () {
      return this.transferInfo.fees_flat || 0
    },
    isDivisionOperator () {
      return this.transferInfo.division_operator
    },
    secondaryCurrencyIsGHS () {
      return this.secondaryCurrency === this.$CURRENCY.GHS
    },
    secondaryCurrencyIsNGN () {
      return this.secondaryCurrency === this.$CURRENCY.NGN
    },
    secondaryCurrencyIsXAF () {
      return this.secondaryCurrency === this.$CURRENCY.XAF
    },
    secondaryCurrencyIsXOF () {
      return this.secondaryCurrency === this.$CURRENCY.XOF
    },
    secondaryCurrencyIsUSD () {
      return this.secondaryCurrency === this.$CURRENCY.USD
    },
    mobileWalletSupportedCurrencies () {
      return (
        this.secondaryCurrencyIsGHS ||
        this.secondaryCurrencyIsXAF ||
        this.secondaryCurrencyIsXOF
      )
    },
    isMobileMoneyPayoutMethod () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails
          .payoutMethod === 'mobile_money'
      )
    },
    mobileMoneyPhoneNumberPlaceholder () {
      let placeholder = ''
      switch (true) {
        case this.secondaryCurrencyIsGHS:
          placeholder = '(0)902 234 567'
          break
        case this.secondaryCurrencyIsXAF:
          placeholder = '902 234 567'
          break
        case this.secondaryCurrencyIsXOF:
          placeholder = '0902 234 567'
          break
        default:
          placeholder = '902 234 568'
      }
      return placeholder
    },
    withdrawalCurrencyIsLocal () {
      const currencies = LOCAL_COUNTRIES.map((asset) => asset.name)
      return currencies.includes(this.withdrawalForm.currency)
    }
  }
}
